export const formatNumber = (num: number): string => {
    // TODO use i18n locale
    return Intl.NumberFormat('ro-RO').format(num);
}

export const formatMedianNumber = (num: number): string => {
    // TODO use i18n locale
    return Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 }).format(num);
}

export const formatPercentage = (num: number, showPlusSign = false, maximumFractionDigits = 0): string => {
    return `${showPlusSign && num > 0 ? '+' : ''}${num.toFixed(maximumFractionDigits)}%`;
}

export const formatCurrency = (num: number, currency: string = 'RON'): string => {
    // TODO use i18n locale
    return Intl.NumberFormat('ro-RO', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(num);
}

export const getCurrentCurrency = (): string => {
    // TODO get from settings
    return 'RON';
}